import * as tslib_1 from "tslib";
import { resetIsContextMenuOpenForLinks, setIsContextMenuOpen } from '../actions/internalActions';
import getLinkContextMenuOptions, { LinkContextMenuOptions } from '../utils/LinkContextMenuOptions';
import { assertNever } from 'owa-assert';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { getOpenInNewTabContextMenuItem } from 'owa-attachment-link-common';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/ContextualMenu';
var LinkContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(LinkContextMenu, _super);
    function LinkContextMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu, { target: this.props.target, shouldFocusOnMount: false, items: this.props.items, directionalHint: 4 /* bottomLeftEdge */ }));
    };
    return LinkContextMenu;
}(React.Component));
var contextMenuDiv = null;
export default function showLinkContextMenu(anchorElement) {
    if (!isAttachmentFeatureEnabled('doc-links-contextMenu')) {
        return;
    }
    removeLinkContextMenu();
    var rect = anchorElement.getBoundingClientRect();
    var target = { x: rect.left, y: rect.bottom };
    contextMenuDiv = document.createElement('div');
    contextMenuDiv.id = 'sharingLinkContextMenu';
    document.body.appendChild(contextMenuDiv);
    ReactDOM.render(React.createElement(LinkContextMenu, { items: getContextMenuItems(anchorElement.href), target: target }), contextMenuDiv);
    setIsContextMenuOpen(anchorElement.id, true);
}
function getContextMenuItems(url) {
    var contextMenuItems = [];
    var contextMenuOptions = getLinkContextMenuOptions();
    contextMenuOptions.forEach(function (contextMenu) {
        switch (contextMenu) {
            case LinkContextMenuOptions.OpenInNewTab:
                contextMenuItems.push(getOpenInNewTabContextMenuItem(url));
                break;
            default:
                assertNever(contextMenu);
        }
    });
    return contextMenuItems;
}
export function removeLinkContextMenu() {
    if (!isAttachmentFeatureEnabled('doc-links-contextMenu')) {
        return;
    }
    if (contextMenuDiv) {
        ReactDOM.unmountComponentAtNode(contextMenuDiv);
        contextMenuDiv.parentNode.removeChild(contextMenuDiv);
        contextMenuDiv = null;
    }
    resetIsContextMenuOpenForLinks();
}
//# sourceMappingURL=LinkContextMenu.js.map